import { render } from "./contact.vue?vue&type=template&id=e8a7662c&scoped=true"
const script = {}

import "./contact.vue?vue&type=style&index=0&id=e8a7662c&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a7662c"]])

export default __exports__